import React from 'react';
import { Form, Button, Col, Row, Accordion } from 'react-bootstrap';
import { FaRegTrashAlt } from 'react-icons/fa';
import { RiAddBoxLine } from 'react-icons/ri';

export default function ModulesTab({ modules, editedModules, setModules, setEditedModules, conditionView, setEnableSaveChanges }) {
  const refArrayModules = React.useRef([]);
  const newGroupModule = React.useRef(null);

  const setAddNewModule = (index) => {
    if (refArrayModules.current[index].value) {
      let newModule = { name: refArrayModules.current[index].value, route: '', isEditing: true };
      const newModules = [...modules];

      if (!newModules[index].children) {
        newModules[index].children = [];
      }

      newModules[index].children.push(newModule);
      setModules(newModules);
      setEditedModules([...editedModules, newModule]);
      setEnableSaveChanges(false);
      refArrayModules.current[index].value = '';
    }
  }

  const handleModuleChange = (indexModule, indexItem, field, value) => {
    const updatedModules = modules.map((module, index) => {
      if (index === indexModule) {
        if (module.children) {
          const updatedChildren = module.children.map((child, childIndex) => {
            if (childIndex === indexItem) {
              return {
                ...child,
                [field]: value,
              };
            }
            return child;
          });

          return {
            ...module,
            children: updatedChildren,
          };
        } else {
          return {
            ...module,
            [field]: value,
          };
        }
      }
      return module;
    });
    setModules(updatedModules);
    setEnableSaveChanges(false);
  };

  const DeleteModule = (index, moduleIndex) => {
    const updatedModules = [...modules];
    updatedModules[index].children.splice(moduleIndex, 1);
    setModules(updatedModules);
    setEnableSaveChanges(false);
  };

  const DeleteAllModule = (index) => {
    const updatedModules = [...modules];
    updatedModules.splice(index, 1);
    setModules(updatedModules);
    setEnableSaveChanges(false);
  };

  const setNewGroupModule = () => {
    if (newGroupModule.current.value) {
      let newModule = { moduleName: newGroupModule.current.value, children: [] };
      setModules(modules => [...modules, newModule]);
      setEnableSaveChanges(false);
      newGroupModule.current.value = '';
    }
  }


  return (
    <>
      <Accordion>
        {modules.map((itemRole, index) => {
          return (
            <Accordion.Item eventKey={index} key={index}>
              <Accordion.Header> {itemRole.moduleName}  </Accordion.Header>
              <Accordion.Body>
                <Row className="mb-3">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Route</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemRole.children ? itemRole.children.map((module, indexItem) => {
                        return (
                          <tr key={index + indexItem}>
                            <td>
                              {module.isEditing ? (
                                <input
                                  type="text"
                                  value={module.name}
                                  onChange={(e) => handleModuleChange(index, indexItem, 'name', e.target.value)}
                                />
                              ) : (
                                module.name
                              )}
                            </td>
                            <td>
                              {module.isEditing ? (
                                <input
                                  type="text"
                                  value={module.route}
                                  onChange={(e) => handleModuleChange(index, indexItem, 'route', e.target.value)}
                                />
                              ) : (
                                module.route
                              )}
                            </td>
                            <td>
                              {!conditionView && !module.isEditing && (
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => handleModuleChange(index, indexItem, 'isEditing', true)}
                                >
                                  Edit
                                </button>
                              )}
                              {!conditionView && module.isEditing && (
                                <button
                                  className="btn btn-outline-success btn-sm"
                                  onClick={() => handleModuleChange(index, indexItem, 'isEditing', false)}
                                >
                                  Save
                                </button>
                              )}
                            </td>
                            <td>
                              {!conditionView && (
                                <button
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={() => DeleteModule(index, indexItem)}
                                >
                                  <FaRegTrashAlt />
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      }) : null}
                    </tbody>
                  </table>
                </Row>
                <Row className="mb-3">

                  {!conditionView ? (<>
                    <Form.Group as={Col} md="6">
                      <Form.Control ref={ref => {
                        refArrayModules.current[index] = ref;
                      }} type="text" placeholder="New Module" />
                    </Form.Group>

                    <Form.Group as={Col} md="3">
                      <Button type="button" onClick={() => setAddNewModule(index)} > <RiAddBoxLine /> </Button>
                    </Form.Group>

                    <Form.Group as={Col} md="3" >
                      <div style={{ float: 'right' }}>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => DeleteAllModule(index)}
                        >
                          <FaRegTrashAlt /> Delete {itemRole.moduleName}
                        </button>
                      </div>
                    </Form.Group>

                  </>) : ('')}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          )
        })}
      </Accordion>

      <hr></hr>
      <Row className="mb-3">
        {!conditionView ? (<>
          <Form.Group as={Col} md="6">
            <Form.Control ref={newGroupModule} type="text" placeholder="New Group of Modules." />
          </Form.Group>

          <Form.Group as={Col} md="4">
            <Button type="button" onClick={() => setNewGroupModule()} > <RiAddBoxLine /> </Button>
          </Form.Group></>) : ('')}
      </Row>
    </>
  );
}